import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import WCToolTip from '@/components/WCToolTip/WCToolTip.vue';
import { ref, onMounted } from 'vue';
import WebPaymentMethod from '@/models/entities/items/web-payment-method';

type DisplayablePaymentOption = WebPaymentMethod & { label: string };


export default /*@__PURE__*/_defineComponent({
  __name: 'WCPaymentOptionBadgeModernCard',
  props: {
    paymentOption: {}
  },
  setup(__props: any) {



const isTruncated = ref(false);
const badgeRef = ref<HTMLElement | null>(null);

onMounted(() => {
  // scrollWidth > clientWidth means the text is clipped by CSS text-overflow,
  // so we show a tooltip with the full label.
  if (badgeRef.value) {
    isTruncated.value = badgeRef.value.scrollWidth > badgeRef.value.clientWidth;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "badgeRef",
    ref: badgeRef,
    class: "wc-payment-badge text-truncate"
  }, [
    _createElementVNode("span", null, _toDisplayString(_ctx.paymentOption.label), 1),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (isTruncated.value)
      ? (_openBlock(), _createBlock(WCToolTip, {
          key: 0,
          target: "badgeRef"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.paymentOption.label), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 512))
}
}

})